/** @module SiteAdmin/SharedSpecSectionsMatrixForProject */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/xml",
	"SpecificationDataSheet/SharedSpecSectionsMatrix"
], function(
	declare,
	_,
	xml,
	SharedSpecSectionsMatrix
) {
	return declare(SharedSpecSectionsMatrix, {
		/**
		 * @override
		 * The incoming nodes will be the projectLineItems for the row, but here want to validate that an item exists
		 * for this spec. And then fetch Product which will have the SharedSectionItemMap
		 */
		_getSpecNodes: function(ctx, spec, nodes) {
			const projectLineItem = nodes[0];
			const item = ctx.cache.get(spec.columnUrl);
			const product = ctx.cache.getNode(projectLineItem.Product);
			const dataSheetItemUrl =
				product && product.SharedSectionItemMap[item.SysID];
			return xml.isValidURL(dataSheetItemUrl) ? nodes : [];
		},
	});
});
